import API_CONFIG from '../../config/api.config';
import AuthService from './auth.service';
import { componentApi } from '../../hooks/useComponents';

class ComponentService {
  static instance = null;

  static getInstance() {
    if (!ComponentService.instance) {
      ComponentService.instance = new ComponentService();
    }
    return ComponentService.instance;
  }

  constructor() {
    // No initialization needed - React Query handles caching
    this.transformComponentData = this.transformComponentData.bind(this);
  }

  transformComponentData(component) {
    return {
      value: component.id.toString(),
      label: component.name,
      secondaryText: component.name_en !== component.name ? component.name_en : null,
      tags: component.tags,
      filters: component.filters
    };
  }

  async getComponents(forceRefresh = false) {
    try {
      // Use the componentApi directly to fetch data
      const data = await componentApi.getComponents();
      return data;
    } catch (error) {
      console.error('Error fetching components data:', error);
      throw error;
    }
  }

  async getComponentAssociations(forceRefresh = false) {
    try {
      // Use the componentApi directly
      const data = await componentApi.getComponentAssociations();
      return data;
    } catch (error) {
      console.error('Error fetching component associations:', error);
      throw error;
    }
  }
}

export default ComponentService.getInstance(); 